import { useEffect } from "react";

export const TITULO_BASE = "Portal de Implantação GEOvendas";

/**
 * Nomeia a aba do navegador conforme a rota. Sem isto toda tela do portal — entrada,
 * convite, recuperação — aparece com o mesmo título no histórico e nas abas abertas.
 */
export function useTitulo(secao?: string): void {
  useEffect(() => {
    document.title = secao ? `${secao} · ${TITULO_BASE}` : TITULO_BASE;
    return () => {
      document.title = TITULO_BASE;
    };
  }, [secao]);
}
